import React, { useEffect } from 'react';

import { useContext } from 'components/Managers/Billing/Context';
import Header from './Header/Index';
import Policy from './Policy/Index';
import PaymentMethods from './PaymentMethods/Index';
import InvoiceHistory from './InvoiceHistory/Index';

export default function Index() {
  const { dispatch, actions, state } = useContext();

  useEffect(() => {
    actions.loadPolicy(dispatch, state.enterpriseId);
    actions.loadPaymentMethods(dispatch);
  }, []);

  return (
    <>
      <div className="content">
        <Header />
        <Policy />
        <PaymentMethods />
      </div>

      <div className="content">
        <InvoiceHistory />
      </div>
    </>
  );
}
